import clsx from 'clsx'

const DEFAULT_OPTIONS = {
  useMiniCard: false,
  hideQuickAdd: true,
  hideSwatches: false,
  hidePromolines: false,
  hideBadges: false,
  hideWishlist: false
}

const SkeletonImage = ({ className }) => (
  <div className={clsx('overflow-hidden relative aspect-3/4 w-full animate-pulse bg-neutral-light', className)} />
)

const SkeletonSwatches = () => (
  <div className="flex gap-x-0.375">
    {[1, 2, 3].map((i) => (
      <span key={i} className="overflow-hidden size-0.75 bg-neutral-light" aria-hidden="true" />
    ))}
  </div>
)

const SkeletonDetails = () => (
  <div className="flex flex-col gap-y-0.5">
    <div className="h-1.125 rounded bg-neutral-light" />
    <div className="h-1.125 rounded bg-neutral-light" />
  </div>
)

const SkeletonPromolines = () => (
  <div className="flex flex-col gap-0.25">
    <div className="h-1.25 w-1/2 rounded bg-neutral-light" />
    <div className="h-1.25 w-1/2 rounded bg-neutral-light" />
  </div>
)

const SkeletonMinicard = () => (
  <div className="flex w-full grow animate-pulse items-stretch gap-x-1 border border-neutral-medium p-1">
    <SkeletonImage className="max-w-[90px] shrink-0" />
    <div className="flex min-w-0 grow flex-col justify-between gap-y-1">
      <div className="flex flex-col justify-between gap-x-0.625 gap-y-0.25 sm:flex-row">
        <div className="h-1.125 max-w-[70%] flex-1 rounded bg-neutral-light" />
        <div className="h-1.125 w-12 rounded bg-neutral-light" />
      </div>
      <div className="flex grid-cols-2 flex-col items-center gap-0.5 lg:grid">
        <div className="h-[56px] rounded-8 bg-neutral-light" />
        <div className="h-[56px] rounded-8 bg-neutral-light" />
      </div>
    </div>
  </div>
)

export const SkeletonCard = ({ className, options = DEFAULT_OPTIONS }) => {
  const { useMiniCard = DEFAULT_OPTIONS.useMiniCard } = options

  if (useMiniCard) {
    return (
      <div className={clsx('group/card relative flex w-full', className)}>
        <SkeletonMinicard />
      </div>
    )
  }

  return (
    <div className={clsx('flex w-full grow flex-col gap-y-0.625', className)}>
      <SkeletonImage />
      <div className="flex animate-pulse flex-col gap-y-0.5">
        {!options.hideSwatches && <SkeletonSwatches />}
        <SkeletonDetails />
        {!options.hidePromolines && <SkeletonPromolines />}
      </div>
    </div>
  )
}
